import React from "react";
import { Box, Typography } from "@mui/material";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import story3 from "../images/GF 2022 .jpg";
import "./Storybottom.css";

const stories = [
  {
    bg: "#faf8f3",
    iconColor: "#faf8f3",
    title: "Raji’s Been A Migrant Worker Since She Was Just 12",
    text: "Raji is a migrant worker since she was just 12. Despite having immense interest in education, she was forced to be a migrant worker due to lack of opportunity and support. She having no regret of those lost 10 years, now is showing much interest in learning and is also supporting underprivileged children learn.",
    img: story3,
    imgAlt: "Raji and child",
  },
];

const storybottom = () => (
  <Box className="story-bottom-container" sx={{ maxWidth: 1200, mx: "auto", my: 6, px: 2 }}>
    {stories.map((story, idx) => (
      <Box
        key={idx}
        className="story-bottom-item"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          background: story.bg,
          borderRadius: "1.5rem",
          boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
          mb: 6,
          overflow: "hidden",
          height: { xs: "auto", md: "500px" },
        }}
      >
        {/* ✅ SWITCH ORDER BASED ON INDEX */}
        {idx === 1 ? (
          <>
            {/* CONTENT FIRST */}
            <Box
              className="story-bottom-content"
              sx={{
                width: { xs: "100%", md: "50%" },
                p: { xs: 3, md: 4 },
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <FormatQuoteIcon
                className="story-bottom-icon"
                sx={{ color: story.iconColor, fontSize: 50, mb: 1 }}
              />
              <Typography
                className="story-bottom-title"
                variant="h6"
                sx={{ fontWeight: 800, mb: 2, color: "#222" }}
              >
                {story.title}
              </Typography>
              <Typography className="story-bottom-text" sx={{ fontSize: "1.05rem", color: "#333" }}>
                {story.text}
              </Typography>
            </Box>

            {/* IMAGE SECOND (Right Side) */}
            <Box
              className="story-bottom-image-container"
              sx={{
                width: { xs: "100%", md: "50%" },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                p: 2,
              }}
            >
              <Box
                className="story-bottom-image"
                component="img"
                src={story.img}
                alt={story.imgAlt}
                sx={{
                  width: "100%",
                  maxWidth: 500,
                  borderRadius: 2,
                  boxShadow: "0 4px 24px rgba(0,0,0,0.1)",
                  objectFit: "cover",
                }}
              />
            </Box>
          </>
        ) : (
          <>
            {/* IMAGE FIRST */}
            <Box
              className="story-bottom-image-container"
              sx={{
                width: { xs: "100%", md: "50%" },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                p: 2,
              }}
            >
              <Box
                className="story-bottom-image"
                component="img"
                src={story.img}
                alt={story.imgAlt}
                sx={{
                  width: "100%",
                  maxWidth: 500,
                  borderRadius: 2,
                  boxShadow: "0 4px 24px rgba(0,0,0,0.1)",
                  objectFit: "cover",
                }}
              />
            </Box>

            {/* CONTENT SECOND */}
            <Box
              className="story-bottom-content"
              sx={{
                width: { xs: "100%", md: "50%" },
                p: { xs: 3, md: 4 },
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <FormatQuoteIcon
                className="story-bottom-icon"
                sx={{ color: story.iconColor, fontSize: 50, mb: 1 }}
              />
              <Typography
                className="story-bottom-title"
                variant="h6"
                sx={{ fontWeight: 800, mb: 2, color: "#222" }}
              >
                {story.title}
              </Typography>
              <Typography className="story-bottom-text" sx={{ fontSize: "1.05rem", color: "#333" }}>
                {story.text}
              </Typography>
            </Box>
          </>
        )}
      </Box>
    ))}
  </Box>
);

export default storybottom;
